<template>
<div>
  <div v-if="$fetchState.pending||loading"><main-loading /></div>
  <div v-else-if="$fetchState.error">An error request not or Internal server error</div>
  <div v-else class="max-w-6xl mx-auto lg:my-12 my-4 sm:px-6 lg:px-8 xl:px-0 px-4">
    <div class="lg:flex block items-center justify-between">
      <div class="font-semibold text-gray-700 text-2xl">
        <span class="text-green-800">{{$t('agri-market')}} - </span> {{$t('weekly-prices')}}
      </div>
      <div class="lg:mt-1 mt-4 flex space-x-6 items-center">
        <div class="text-green-700 text-sm">
          <select v-model="filter.district" class="focus:outline-none">
            <option v-for="(district, index) in districts" :key="index" :value="district.id">
              {{ district.name }}
            </option>
          </select>
        </div>
        <div class="text-green-700 text-sm">
          <select v-model="filter.category" class="focus:outline-none">
            <option v-for="(category, index) in categories" :key="index" :value="category.id">
              {{ category.name }}
            </option>
          </select>
        </div>
<!--        <div class="text-green-700 text-sm">-->
<!--          <select v-model="filter.pricedate" class="focus:outline-none">-->
<!--            <option v-for="(priceDate, index) in priceDates" :key="index" :value="priceDate.id">-->
<!--              {{ $tools.getDate(priceDate.attributes.date) }}-->
<!--            </option>-->
<!--          </select>-->
<!--        </div>-->
        <nuxt-link
          :to="{path: localePath('/graph')}"
          class="
            text-green-700 text-sm
            border border-green-700
            rounded-md
            px-3
            py-1.5
            focus:outline-none
          "
        >
          {{ $t('compare') }}
        </nuxt-link>
      </div>
    </div>
    <div v-if="pricList && pricList.length" class="grid md:grid-cols-4 gap-4 sm:grid-cols-2 grid-cols-1 mt-8">
      <div v-for="(price, index) in pricList" :key="index">
        <prices :data="price" />
      </div>
    </div>
    <div v-else class="flex justify-center py-5">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Layer_1" data-name="Layer 1" viewBox="0 0 544.16 453.28" width="406" height="306" class="illustration styles_illustrationTablet__1DWOa"><defs><linearGradient id="linear-gradient" x1="291.64" y1="380.92" x2="289.63" y2="204.96" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#010101" stop-opacity="0"/><stop offset="0.95" stop-color="#010101"/></linearGradient><linearGradient id="linear-gradient-2" x1="188.63" y1="205.15" x2="247.68" y2="205.15" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-3" x1="312.7" y1="161.49" x2="302" y2="343.42" xlink:href="#linear-gradient"/><linearGradient id="linear-gradient-4" x1="188.98" y1="236.28" x2="190.32" y2="259.03" xlink:href="#linear-gradient"/></defs><title>Inbox Empty</title>
        <path d="M556.11,354.92a53.22,53.22,0,0,1-1.56,8.7,74.63,74.63,0,0,1-7.86,18.78c-20.07,35-59.37,55.27-98.92,63.54s-80.38,6.47-120.73,8.32c-54.5,2.47-108.86,11.61-163.36,8.62A368.92,368.92,0,0,1,87.26,450.5c-120.37,0-61.52-183.82-54.6-253.51,3-30,6.48-61.49,23.61-86.33,20.27-29.37,56.16-44,91.27-50.4s71.24-6,106.16-13.37c57-12,112.19-44.27,169.74-35.07,56.45,9,102.26,62.77,102.23,119.94,0,40.13-18.21,80-7.76,120C527,286.45,559.61,317.17,556.11,354.92Z" transform="translate(-12.22 -10.2)" fill="#064E3B" opacity="0.24" style="isolation: isolate;"/>
        <path d="M554.55,363.62a74.63,74.63,0,0,1-7.86,18.78c-20.07,35-59.37,55.27-98.92,63.54s-80.38,6.47-120.73,8.32c-54.5,2.47-108.86,11.61-163.36,8.62A368.92,368.92,0,0,1,87.26,450.5c-16.73-4.56-51.3-10.5-61.42-26-6.33-9.67-7.37-27.79-7.58-43.06,3.79.6,7.55,1.5,10.85,1.81,11.2,1.08,22.54,1.15,33.77,1.5q35.68,1.14,71.41,1.53,142.22,1.51,284.23-9.36Q486.65,371.68,554.55,363.62Z" transform="translate(-12.22 -10.2)" fill="#064E3B" opacity="0.24" style="isolation: isolate;"/>
        <rect x="277.56" y="237.48" width="26.76" height="165.03" fill="#064E3B"/>
        <rect x="277.56" y="237.48" width="26.76" height="165.03" fill="url(#linear-gradient)"/>
        <path d="M379.45,197v65.4H196.1V197A34.08,34.08,0,0,1,230.23,163h115.1A34.11,34.11,0,0,1,379.45,197Z" transform="translate(-12.22 -10.2)" fill="#064E3B"/>
        <path d="M218.15,158.44h0A29.52,29.52,0,0,1,247.68,188v63.9a0,0,0,0,1,0,0h-59a0,0,0,0,1,0,0V188A29.52,29.52,0,0,1,218.15,158.44Z" fill="url(#linear-gradient-2)"/>
        <path d="M379.46,197V262.4h-113V193.19c-3.37-18.09-16.1-26.4-26.57-30.23H345.34A34.1,34.1,0,0,1,379.46,197Z" transform="translate(-12.22 -10.2)" fill="url(#linear-gradient-3)"/>
        <rect x="125.02" y="242.83" width="129.25" height="9.39" rx="4.69" fill="#064E3B"/>
        <rect x="125.02" y="242.83" width="129.25" height="9.39" rx="4.69" fill="url(#linear-gradient-4)"/>
        <path d="M232.27,398.24c-15.57,2.78-31,6.39-46.77,7.91-10.22,1-21.5,1.51-28.92,8.62a9.72,9.72,0,0,0-3.29,5.88c-.43,4.92,4.72,8.35,9.31,10.16,13.41,5.3,28,6.82,42.38,7.74,23.45,1.49,47,1.51,70.45,1.53l70,.07c20.66,0,43.6-.84,58.4-15.26,2.93-2.85,5.51-6.37,6-10.43.82-6.58-4.17-12.76-10.2-15.51-10.44-4.77-26.06-3.78-37.44-5-14.79-1.64-29.67-2.54-44.55-2.72A455.74,455.74,0,0,0,232.27,398.24Z" transform="translate(-12.22 -10.2)" fill="#064E3B" opacity="0.24" style="isolation: isolate;"/>
        <path d="M209.55,206.64c-17.47,0-34.4-5.3-47.55-15.07a48.68,48.68,0,0,1-9.16-8.73A34.33,34.33,0,0,1,138.73,178,42.67,42.67,0,0,1,137,105.76l1.92,2.9A39.18,39.18,0,0,0,140.51,175a32.39,32.39,0,0,0,9.66,3.89,25,25,0,0,1-3.46-11.12,19.65,19.65,0,0,1,6.74-15.43,13.49,13.49,0,0,1,21,2.85,16.41,16.41,0,0,1,2.36,12.29c-1.61,7.33-8.16,13.36-16.31,15a24.61,24.61,0,0,1-3,.41,48.16,48.16,0,0,0,6.61,5.88c14.84,11,34.76,16.08,54.63,13.87l.38,3.46A84.81,84.81,0,0,1,209.55,206.64Zm-54.88-27.16a24,24,0,0,0,5.11-.4c6.71-1.35,12.29-6.41,13.59-12.32a13.07,13.07,0,0,0-1.88-9.66,10,10,0,0,0-15.77-2.1,16,16,0,0,0-5.54,12.59A22.8,22.8,0,0,0,154.67,179.48Z" transform="translate(-12.22 -10.2)" fill="#fff"/>
        <path d="M151.68,98.61a21.57,21.57,0,0,1,9.06-11.83c5.46-3.37,12.16-3.88,18.56-4.31A8.49,8.49,0,0,0,176.21,88c-.39,2.14-.35,4.34-.68,6.49a19.55,19.55,0,0,1-18.78,16.07c-.85-4.59,2.41-8.82,5.47-12.35a10,10,0,0,0-7,7.71,39.61,39.61,0,0,1-.63,4.5c-.28.93-1.53,3.18-2.81,2.7-.93-.35-1-3.75-1.11-4.6A25,25,0,0,1,151.68,98.61Z" transform="translate(-12.22 -10.2)" fill="#064E3B"/>
        <path d="M102.13,119.25a37.48,37.48,0,0,0,1,7.32,12.56,12.56,0,0,0,3.68,6.28,41.52,41.52,0,0,1,3.66,2.89.52.52,0,0,0,.27.2c1.15.3,2.27-4.27,2.25-5.06a11.59,11.59,0,0,0-1.81-4.86A13.31,13.31,0,0,0,102.13,119.25Z" transform="translate(-12.22 -10.2)" fill="#064E3B"/>
      </svg>
    </div>
  </div>
</div>
</template>

<script>
import Prices from '~/components/Prices.vue'
import { mapGetters } from 'vuex'
import { actions, getters } from '~/utils/store_schema'
const _page = 'pricelists'
const { get } = actions(_page)
export default {
  name: 'AgriMarket',
  auth: false,
  components: { Prices },
  data() {
    return {
      pricList: [],
      regionId: {
        en: 18,
        ru: 36,
        uz: 37,
        kaa: 38
      },
      filter: {
        district: this.$route.query.district ?? 5,
        category: 'all',
        pricedate: null
      },
      loading: false,
      districts: [],
      categories: [],
      // priceDates: []
    }
  },
async fetch() {
  try {
    await this.fetchDirectories();
    await this.setQuery()
    await this.fetchPriceLists()
  } catch (err) {
    console.log(err)
  }
},
  computed: {
    ...mapGetters({
      ...getters(_page),
    }),
  },
  watch: {
    filter: {
      handler() {
        this.setQuery()
      },
      deep: true,
    },
    '$route.query': {
      handler() {
        this.fetchPriceLists()
      },
      deep: true,
    },
  },
  methods: {
    checkProductLocalizations (item, lang) {
      let _ =item.find((el) =>el.attributes.locale === lang).attributes.name;
     return  _;
    },
    async setQuery () {
      await this.$router.push({
        path: this.$route.path,
        query: {
          district: this.filter.district,
          category: this.filter.category,
          // pricedate: this.filter.pricedate
        }
      })
    },
   async fetchPriceLists() {
     let id;
     await this.$store.dispatch('getPricedates', {
       populate: '*',
       locale: this.$i18n.locale,
       sort: 'createdAt:DESC'
     }).then(res => {
       // this.priceDates = res
      id = res[0].id
     })
     const _ = {
        populate: 'product,product.localizations',
        locale: this.$i18n.locale,
        "filters[$and][0][district][id]": this.$route.query.district ,
        "filters[$and][0][pricedate][id]": id,
        // "filters[max][$ne]": 0,
        filters: {
          max: {
            $gt: 0
          },
          min: {
            $gt: 0
          }
        },
        "filters[product][productcategory][id][$eq]": this.$route.query.category !== 'all' ? this.$route.query.category : null,
        'sort[0][product][name]': 'ASC',
      }
     try {
       await this.$store.dispatch(get, _)
         .then(res => {
           this.pricList = res.map((el) => {
               return {
                 id: el.id,
                 attributes: {
                   ...el.attributes,
                   product: {
                     data: {
                       attributes: {
                         image: el.attributes.product.data.attributes.image,
                         name:
                           el.attributes.product.data.attributes.locale === this.$i18n.locale
                             ? el.attributes.product.data.attributes.name
                             : this.checkProductLocalizations(el.attributes.product.data.attributes.localizations.data, this.$i18n.locale)
                       }
                     }
                   }
                 }

               }
             })
         })

     } catch (err) {
       console.log(err)
     }
    },
    async fetchDirectories() {
      try {
        await this.$store.dispatch('getDistricts', {
          populate: '*',
          "filters[$and][0][region][id]": this.regionId[this.$i18n.locale],
          locale: this.$i18n.locale,
        }).then(res => {
          this.districts = res
            .map((e) => {
              return {
                id: e.attributes.locale === 'en'? e.id : this.$tools.getDefaultLanguageID(e.attributes.localizations.data),
                name: e.attributes.name,
              }
            });
          this.filter.district = this.districts[0].id
          // if (res.districts((el) => el.id).includes(this.$route.query.district)) {
          //   this.filter.district = parseInt(this.$route.query.district)
          // }  else  {
          //   this.filter.district = this.districts[0].id
          // }
        })
        await this.$store.dispatch('getProductcategories', {
          populate: '*',
          // locale: this.$i18n.locale,
        }).then(res => {
          this.categories = res
            .map((e) => {
              return {
                id: e.attributes.locale === 'en'? e.id : this.$tools.getDefaultLanguageID(e.attributes.localizations.data),
                name: e.attributes.locale ===this.$i18n.locale ? e.attributes.name :  this.$tools.getDefaultLanguageName(e.attributes.localizations.data, this.$i18n.locale).name,
              }
            })

          this.categories.unshift({
                id: 'all',
              name: this.$t('all-products'),
          })
          this.filter.category = this.categories[0].id
        })

      } catch (err) {
        return new Error(err)
      }
    }
  },
}
</script>
